import { startOfDay } from 'date-fns'

import { transposeToUkTimezoneDate } from '../../../../../utils/date'

export function getNextDateValue(value, timezone) {
  return transposeToUkTimezoneDate(value ? startOfDay(value) : null, timezone)
}
